import React from 'react';

export const renderAcceptableValues = (acceptableValues) => {
    return acceptableValues.map((value, i) => (
        <span key={i}>{value}{i !== acceptableValues.length - 1 ? ' ' : ''}</span>
    ));
};
